<script setup lang="ts">
  import { ref, computed, watch } from 'vue';
  import { VueFinalModal } from 'vue-final-modal';
  import { UiModalHeader, FormInput, ColoredButton, ThemeProvider } from '@/shared/ui';
  import CheckMarkIcon from '@/shared/assets/icons/CheckMarkIcon.svg';

  const props = defineProps<{
    title?: string;
    nameError?: string;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'save', data: { name: string }): void;
  }>();

  const name = ref('');
  const localNameError = ref('');

  watch(
    () => props.nameError,
    (val) => {
      localNameError.value = val ?? '';
    },
    { immediate: true }
  );

  watch(name, () => {
    localNameError.value = '';
  });

  const isFormValid = computed(() => !!name.value.trim());

  const handleClose = () => {
    emit('close');
  };

  const handleSave = () => {
    emit('save', { name: name.value.trim() });
  };

  const handleClosed = () => {
    name.value = '';
    localNameError.value = '';
  };
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl w-[900px] shadow-lg"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    @closed="handleClosed"
  >
    <ThemeProvider class="flex flex-col">
      <div class="flex flex-col">
        <UiModalHeader
          class="px-6 py-4 text-sm border-b border-gray-02 shrink-0"
          :title="title || 'Nova Atividade Funcional'"
          @close="handleClose"
        />

        <div class="px-6 py-6 space-y-6">
          <FormInput
            id="functional-activity-name"
            v-model="name"
            label="Atividade Funcional:"
            type="text"
            placeholder="Escreva o título da Atividade"
            label-class="text-sm text-gray-07 font-semibold"
            :max-length="255"
            :error="localNameError"
          />
        </div>

        <div class="px-6 py-8 flex justify-end gap-3 border-t border-gray-02 shrink-0">
          <ColoredButton
            text="Cancelar"
            outlined
            color="gray-03"
            @click="handleClose"
          />
          <ColoredButton
            :disabled="!isFormValid"
            text="Salvar"
            :icon="CheckMarkIcon"
            @click="handleSave"
          />
        </div>
      </div>
    </ThemeProvider>
  </VueFinalModal>
</template>

<style scoped>
  .vfm__overlay {
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
